import { MutationTree } from 'vuex';
import { NewsMutations, NewsState } from './types';
import { NewsPage } from '@mentessa/types';

export const mutations: MutationTree<NewsState> = {
  [NewsMutations.SetNews](state: NewsState, page: NewsPage) {
    state.news = page;
  },
};
